<p-accordion>
  <p-accordionTab [selected]="openedAccordion">
    <query-builder #qB data-testid="qB" [formControl]="ctrl" [(ngModel)]='query' [config]='config'>
      <!-- Rule Buttons -->
      <ng-container *queryButtonGroup="let ruleset; let addRule=addRule; let addRuleSet=addRuleSet; let removeRuleSet=removeRuleSet">
        <button type="button" class="rule-button" (click)="addRule()">+ {{ 'common.rule' | translate }}</button>
        <button type="button" class="rule-button" (click)="addRuleSet()">+ {{ 'common.ruleset' | translate }}</button>
        <button *ngIf="removeRuleSet" type="button" class="rule-button" (click)="removeRuleSet()"><span class="remove-icon"></span></button>
      </ng-container>
      <!-- Condition Buttons -->
      <ng-container *querySwitchGroup="let ruleset; let i = index">
        <div id="ruleset-condition-radio-container">
          <p-radioButton *ngIf="ruleset" class="ruleset-condition-radio" [name]="i" [(ngModel)]="ruleset.condition" label="{{'common.and' | translate}}" value="and"></p-radioButton>
          <p-radioButton *ngIf="ruleset" class="ruleset-condition-radio" [name]="i" [(ngModel)]="ruleset.condition" label="{{'common.or' | translate}}" value="or"></p-radioButton>
        </div>
      </ng-container>
      <!-- Text Input -->
      <ng-container *queryInput="let rule; let field=field; type: 'string'">
        <input *ngIf="controlOperator(rule.operator)" type="text" [ngModel]="rule.value" (ngModelChange)="rule.value = removeWildcard($event)" (keypress)="blockWildcard($event)" (input)="cleanWildcardInput($event)" style="height: 32px;" [maxlength]="field.maxLength">
      </ng-container>
      <!-- Email Input -->
      <ng-container *queryInput="let rule; type: 'email'">
        <input *ngIf="controlOperator(rule.operator)" pInputText type="email" [(ngModel)]="rule.value" style="height: 32px;">
      </ng-container>
      <!-- Tel Input -->
      <ng-container *queryInput="let rule; type: 'tel'">
        <input *ngIf="controlOperator(rule.operator)" pInputText type="tel" [(ngModel)]="rule.value" style="height: 32px;">
      </ng-container>
      <!-- Number Input -->
      <ng-container *queryInput="let rule; type: 'number'">
        <!-- Aggiunti Input e controlli per operatore Between-->
        <input *ngIf="controlOperator(rule.operator) && rule.operator !== 'between'" pInputText type="number" [(ngModel)]="rule.value" style="height: 32px;">
        <input #numberStartRef data-testid="numberStartRef" *ngIf="controlOperator(rule.operator) && rule.operator === 'between'" pInputText type="number" (input)="convertNumber(rule,numberStartRef,'startValue')" [ngModel]="rule.startValue" style="height: 32px;">
        <input #numberEndRef data-testid="numberEndRef" *ngIf="controlOperator(rule.operator) && rule.operator === 'between'" pInputText type="number" (input)="convertNumber(rule,numberEndRef,'endValue')" [ngModel]="rule.endValue" style="height: 32px;">
      </ng-container>
      <!-- Date Input -->
      <ng-container *queryInput="let rule; type: 'date'; let operators=operators">
        <!-- Singola Data -->

          <p-calendar
          *ngIf="rule.operator !== 'between'"
          #dateFieldRef
          [dateFormat]="srvCalendarTranslate.pcalendarTranslate.dateFormat"
          [locale]="srvCalendarTranslate.pcalendarTranslate"
          showIcon="true"
          inputName="dateField"
          [monthNavigator]="true"
          [yearNavigator]="true"
          [yearRange]="'1900:2099'"
          [ngModel]="rule.dateValue"
          [placeholder]="srvCalendarTranslate.pcalendarTranslate.dateFormat"
          [inputStyle]="{'height':'32px'}"
          readonlyInput="true"
          (onSelect)="convertDate(rule,dateFieldRef,'dateValue')"
        ></p-calendar>
        <!-- Intervallo di Date -->
        <p-calendar
          *ngIf="rule.operator === 'between'"
          #dateFieldRefStart
          [dateFormat]="srvCalendarTranslate.pcalendarTranslate.dateFormat"
          [locale]="srvCalendarTranslate.pcalendarTranslate"
          showIcon="true"
          inputName="dateStartField"
          [monthNavigator]="true"
          [yearNavigator]="true"
          [yearRange]="'1900:2099'"
          [ngModel]="rule.startValue"
          [placeholder]="srvCalendarTranslate.pcalendarTranslate.dateFormat"
          [inputStyle]="{'height':'32px'}"
          readonlyInput="true"
          (onSelect)="convertDate(rule,dateFieldRefStart,'startValue')"
        ></p-calendar>
        <p-calendar
          *ngIf="rule.operator === 'between'"
          #dateFieldRefEnd
          [dateFormat]="srvCalendarTranslate.pcalendarTranslate.dateFormat"
          [locale]="srvCalendarTranslate.pcalendarTranslate"
          showIcon="true"
          inputName="dateEndField"
          [monthNavigator]="true"
          [yearNavigator]="true"
          [yearRange]="'1900:2099'"
          [ngModel]="rule.endValue"
          [placeholder]="srvCalendarTranslate.pcalendarTranslate.dateFormat"
          [inputStyle]="{'height':'32px', 'margin-left': '40px'}"
          readonlyInput="true"
          (onSelect)="convertDate(rule,dateFieldRefEnd,'endValue')"
        ></p-calendar>


      </ng-container>
    </query-builder>
    <p class="input-error-notification" *ngIf="ctrl.invalid && submitted">{{ 'common.allFieldsRequired' | translate }}</p>
    <div style="text-align: right; width: 100%; margin-top: 15px;">
      <button
        pButton
        *ngIf="showSendQueryBtn"
        type="button"
        class="k-generic-btn"
        label="{{ 'common.startSearch' | translate }}"
        (click)="sendQuery()"
      ></button>
    </div>
  </p-accordionTab>
</p-accordion>



// WEBPACK FOOTER //
// ./src/app/modules/UIKit/components/kv-ext-search/kv-ext-search.component.html